import React, {useEffect, useState } from 'react';
import './App.css';
import {Container} from 'react-bootstrap';
import NavBarMenu from "./components/NavBarMenu";
import HomePage from "./pages/HomePage";
import Posts from './Posts/Posts';

function App() {
  return (
    <>
      <NavBarMenu/>
      <HomePage/>
    </>
  );
}

export default App;
